import React from 'react'
import { Add, Edit, Clear } from '@material-ui/icons'

export function userCard (
  i, // : number,
  user, // : any,
  style = 'base',
  onRemove, // : (i: number) => void,
  isActive, // : boolean,
  isViewMode, // : boolean,
  isDeletable // : boolean
) {
  let color
  switch (style) {
    case 'base':
      color = 'bg-1'
      break
    case 'general':
      color = 'bg-3'
      break
    case 'manager':
      color = 'bg-4'
      break
    default:
      color = 'bg-7'
      break
  }
  return (
    <div className="d-flex w-100 my-1" key={`${user.id}-${i}`}>
      <button type="button" className={`btn btn-lg ${color} flex-fill ${isActive ? 'opacity10' : 'opacity3'}`} disabled>{user.name}</button>
      {(!isViewMode && isDeletable) && <button type="button" className={'btn bg-8 p-1 ml-1 flex-grow-0 flex-shrink-1 align-self-center'} onClick={() => onRemove(i)}><Clear/></button>}
    </div>
  )
}

export function flowElement (
  i, // : number,
  users, // : any,
  onAdd, // : () => void | null,
  onEdit, // : () => void | null,
  onRemove, // : () => void | null,
  isActive, // : boolean,
  isViewMode, // : boolean,
  isDeletable // : boolean
) {
  const isGroup = users.length > 1
  if (!onAdd) {
    onAdd = () => {}
  }
  if (!onEdit) {
    onEdit = () => {}
  }
  if (!onRemove) {
    onRemove = () => {}
  }
  return (
    <div key={`${users.map((u) => u.id).join('-')}-${i}`}>
      { isViewMode
        ? (
        <div>▼</div>
          )
        : (
        <button type="button" className="btn btn-sm btn-secondary p-1" onClick={onAdd} disabled={!isActive}><Add/></button>
          )}
      <div className={`${isGroup ? 'border border-dot ol-1 rounded p-2 my-1' : ''} d-flex`}>
        <div className="d-flex flex-column flex-fill">
          {users.map((user) => userCard(i, user, user.is_manager === 0 ? 'general' : 'manager', onRemove, isActive, isViewMode, isDeletable && !isGroup))}
          {isGroup && (<small>誰か一名が承認すると次段階へ進みます</small>)}
        </div>
        {(isGroup && !isViewMode && isDeletable) && (
          <div className="d-flex flex-column ml-1 my-1">
            <button type="button" className="btn bg-8 p-1 mb-auto" onClick={onRemove}><Clear/></button>
            <button type="button" className="btn bg-1 p-1 mt-auto"><Edit onClick={onEdit}/></button>
          </div>
        )}
      </div>
    </div>
  )
}

export function flowTail (
  onAdd, // : () => void | null,
  isActive, // : boolean,
  isViewMode // : boolean
) {
  if (!onAdd) {
    onAdd = () => {}
  }
  return (
    <div>
      { isViewMode
        ? (
        <div>▼</div>
          )
        : (
        <button type="button" className={`btn btn-sm btn-secondary ${isActive ? 'opacity10' : 'opacity3'} p-1`} onClick={onAdd} disabled={!isActive}><Add/></button>
          )}
      <div>
        <button type="button" className="btn btn-lg bg-1 w-100 opacity10 mt-1" disabled>承認</button>
      </div>
    </div>
  )
}
